module.exports = __webpack_public_path__ + "static/media/golf-carousel-800x1280.40f4cc1d.jpg";